import useSWR from 'swr';

const useScenariosByAnalysisId = (analysisId) => {
    const { data, error } = useSWR(
        analysisId ? `/analyses/${analysisId}/scenarios` : null
    );
    return {
        scenarios: data,
        isLoading: !error && !data,
        isError: error,
    };
};

export default useScenariosByAnalysisId;
